import React, { useState, useEffect, useRef } from "react";
import HTMLFlipBook from "react-pageflip";

function importAllImages(r) {
  return r
    .keys()
    .sort((a, b) => {
      const numA = parseInt(a.match(/\d+/)[0]);
      const numB = parseInt(b.match(/\d+/)[0]);
      return numA - numB;
    })
    .map((filename) => r(filename));
}

const images = importAllImages(require.context("../../../public/images/flipbook", false, /\.(png|jpe?g|svg)$/));

const FlipBook = () => {
  const [isOpened, setIsOpened] = useState(false);
  const [bookWidth, setBookWidth] = useState(600);
  const flipBookRef = useRef(null);

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      console.log("Screen width:", width); // ✅ Debug line
  
      if (width >= 1500) {
        setBookWidth(690);
      } else if (width >= 800 && width < 1499) {
        setBookWidth(600);
      } else {
        setBookWidth(300);
      }
    };
  
    handleResize(); 
  
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  

  useEffect(() => {
    const handleInteraction = () => setIsOpened(true);
    window.addEventListener("scroll", handleInteraction);
    window.addEventListener("click", handleInteraction);
    return () => {
      window.removeEventListener("scroll", handleInteraction);
      window.removeEventListener("click", handleInteraction);
    };
  }, []);

  const nextPage = () => flipBookRef.current?.pageFlip().flipNext();
  const prevPage = () => flipBookRef.current?.pageFlip().flipPrev();

  return (
    <div className="relative flex overflow-hidden justify-center over items-center h-screen mt-10 lg:mt-10">
      {/* Flipbook */}
      <HTMLFlipBook
        width={bookWidth}
        height={800}
        className="flex center"
        maxShadowOpacity={0}
        drawShadow={false}
        showCover={true}
        startPage={isOpened ? 0 : -1}
        ref={flipBookRef}
      >
        {images.map((src, index) => (
          <div key={index} className="page w-full overflow-hidden h-full flex items-center justify-center">
            <img src={src} alt={`Page ${index + 1}`} className="h-full object-contain" />
          </div>
        ))}
      </HTMLFlipBook>

      {/* Navigation Arrows */}
      <button
        onClick={prevPage}
        className="absolute left-10 sm:left-10 top-1/2 bg-gray-700 text-white px-3 sm:px-4 py-2 rounded-l-lg shadow-md hover:bg-gray-900 transition text-sm sm:text-base"
      >
        ❮
      </button>
      <button
        onClick={nextPage}
        className="absolute right-10 sm:right-10 top-1/2 bg-gray-700 text-white px-3 sm:px-4 py-2 rounded-r-lg shadow-md hover:bg-gray-900 transition text-sm sm:text-base"
      >
        ❯
      </button>
    </div>
  );
};

export default FlipBook;
